export function getBillingStatusBanner(payment) {
  if (payment === "incomplete") {
    return {
      title: "Payment wasn’t completed",
      copy: "Finish upgrade or keep your free month of Fun.",
      tone: "neutral",
    };
  }
  if (payment === "complete") {
    return {
      title: "Payment confirmed",
      copy: "Your plan is active and Min has switched your account over.",
      tone: "success",
    };
  }
  if (payment === "cancelled") {
    return {
      title: "Checkout cancelled",
      copy: "Nothing changed. You can restart checkout whenever you want.",
      tone: "neutral",
    };
  }
  if (payment === "failed") {
    return {
      title: "Payment failed",
      copy: "PayFast did not confirm the payment. Try again when you’re ready.",
      tone: "danger",
    };
  }
  if (payment === "pending") {
    return {
      title: "Waiting for confirmation",
      copy: "PayFast sent you back before the callback finished. This page will refresh the latest status.",
      tone: "neutral",
    };
  }
  if (payment === "missing_transaction") {
    return {
      title: "We couldn’t find that checkout",
      copy: "Start a new checkout if you still want to switch plans.",
      tone: "danger",
    };
  }
  return null;
}

export function getPayfastMerchantNotice() {
  return {
    title: "Before you pay",
    copy: "Secure checkout opens on PayFast. Tech Local may appear there as the merchant because it is Min's parent company.",
  };
}

export function shouldShowPayfastMerchantNotice(planCode) {
  const normalized = String(planCode || "").trim().toLowerCase();
  return normalized !== "" && normalized !== "free";
}

export function getPaidConversionStorageKey(transactionId) {
  return `mincool.paidConversion.${transactionId}`;
}
